import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import ReactHtmlParser, { convertNodeToElement, processNodes, } from 'react-html-parser';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
/**
 * 静的ページ用のHTML string -> react nodeへのparse
 * @param options
 * @returns
 */
export const useStaticPageHtmlParser = (options) => {
    const { html } = options;
    return useMemo(() => {
        const transform = (node, index) => {
            var _a, _b;
            if (node.type === 'tag') {
                if (node.name === 'h3') {
                    return (_jsx(Head, Object.assign({ color: 'base', size: 'xl', tagName: 'h3' }, { children: processNodes(node.children, transform) }), index));
                }
                if (node.name === 'h4') {
                    return (_jsx(Head, Object.assign({ className: clsx('mt-16'), color: 'base', id: node.attribs.id, size: 'md', tagName: 'h4' }, { children: processNodes(node.children, transform) }), index));
                }
                if (node.name === 'h5') {
                    return (_jsx(Head, Object.assign({ color: 'base', size: 'xs', tagName: 'h5' }, { children: processNodes(node.children, transform) }), index));
                }
                if (['ol', 'ul'].includes(node.name)) {
                    const convertedNode = node;
                    convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', 'list-decimal', 'flex flex-col gap-y-8', 'pl-20');
                    return convertNodeToElement(convertedNode, index, transform);
                }
                if (node.name === 'li') {
                    if (((_a = node.parent) === null || _a === void 0 ? void 0 : _a.name) === 'ol') {
                        let liNestCount = 0;
                        let findNode = node.parent.parent;
                        do {
                            if ((findNode === null || findNode === void 0 ? void 0 : findNode.name) === 'ol' || (findNode === null || findNode === void 0 ? void 0 : findNode.name) === 'ul') {
                                liNestCount += 1;
                            }
                            findNode = findNode === null || findNode === void 0 ? void 0 : findNode.parent;
                        } while (findNode);
                        return (_jsx("li", Object.assign({ className: clsx(node.attribs.class, 'first:mt-8', 'pl-4', liNestCount > 0 &&
                                "[counter-increment:cnt] marker:[content:'('_counter(cnt)_')']") }, { children: _jsx(Text, Object.assign({ color: 'base' }, { children: processNodes(node.children, transform) })) }), index));
                    }
                    if (((_b = node.parent) === null || _b === void 0 ? void 0 : _b.name) === 'ul') {
                        return (_jsx("li", Object.assign({ className: clsx(node.attribs.class, 'list-disc first:mt-8', 'pl-4') }, { children: _jsx(Text, Object.assign({ color: 'base', tagName: 'span' }, { children: processNodes(node.children, transform) })) }), index));
                    }
                }
                if (node.name === 'tr') {
                    const convertedNode = node;
                    convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', 'block md:table-row');
                    return convertNodeToElement(convertedNode, index, transform);
                }
                if (node.name === 'th') {
                    const convertedNode = node;
                    convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', 'block md:table-cell', 'whitespace-nowrap', 'md:py-16 md:pr-32', 'text-left');
                    return convertNodeToElement(convertedNode, index, transform);
                }
                if (node.name === 'td') {
                    const convertedNode = node;
                    convertedNode.attribs.class = clsx(convertedNode.attribs.class || '', 'block md:table-cell', 'py-16 md:px-32', 'text-left');
                    return convertNodeToElement(convertedNode, index, transform);
                }
                if (node.name === 'p') {
                    return (_jsx(Text, Object.assign({ color: 'base', tagName: 'p' }, { children: processNodes(node.children, transform) }), index));
                }
            }
            return undefined;
        };
        return ReactHtmlParser(html, { transform });
    }, [html]);
};
